module.exports = __webpack_public_path__ + "img/safe_tool_0.b95b89f0.jpg";